import * as React from 'react'
import Svg, { Path } from 'react-native-svg'
import { Props } from './type'
export const SuccessIcon = (props: Props) => (
  <Svg viewBox='0 0 41 40' fill='none' {...props}>
    <Path
      d='M15.1585 26.4583L8.20846 19.5083L5.8418 21.8583L15.1585 31.175L35.1585 11.175L32.8085 8.82501L15.1585 26.4583Z'
      fill='#14AE5C'
    />
  </Svg>
)
